
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10.442 2.515A6 6 0 1014 7.999v-.613a.667.667 0 011.333 0v.613a7.334 7.334 0 11-4.348-6.702.667.667 0 01-.543 1.218z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M15.138 2.195c.26.26.26.682 0 .943L8.472 9.81a.667.667 0 01-.943 0l-2-2a.667.667 0 11.942-.942L8 8.397l6.195-6.202c.26-.26.682-.26.943 0z"}})])
          )
        }
      }
    